import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { PropsWithChildren, useRef } from 'react'

// import { useStore } from '../root'

export type Props = object
const QueryProvider = (props: PropsWithChildren<Props>) => {
  const { children } = props
  // const { message } = useStore()
  const queryClient = useRef(
    new QueryClient(),
    // TODO report errors
    // {
    //   defaultOptions: {
    //     queries: {
    //       retry: false,
    //       onError: (error) => {
    //         message.add({
    //           message: (error as Error).message,
    //           status: 'error',
    //         })
    //       },
    //     },
    //   },
    // }
  ).current

  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
}

export default QueryProvider
